import { useRef } from 'react'

export function useDragDrop({ list, setList }) {
  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (position) => {
    dragItem.current = position
  }

  const dragEnter = (position) => {
    dragOverItem.current = position
  }

  /*  this function receives as a string, the name in witch view the list is going to be sorted
  /   for example to set an specific order in home the props its "home", for a product the prop could be "tensoblock"
  /   and thats how the list is going to be sorted in the view
  */

  const drop = (view) => {
    let copyListItems = [...list]
    const dragItemContent = copyListItems[dragItem.current]

    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)

    copyListItems = copyListItems.map((item, index) => {
      return {
        ...item,
        position: [{ [view]: index }],
      }
    })

    dragItem.current = null
    dragOverItem.current = null
    setList(copyListItems)
  }

  return {
    dragStart,
    dragEnter,
    drop,
  }
}
